













import Vue from "vue";
import Otp from "./partials/Otp.vue";

export default Vue.extend({
  components: {
    Otp
  },
  methods: {
    parseData(dataStr) {
      return JSON.parse(dataStr);
    },
    imageSrc(dataStr) {
      const qr = this.parseData(dataStr).qr;
      return `data:image/png;base64,${qr}`;
    }
  }
});
